"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const customDayFooter = ({ colSpan, style, ariaColumnIndex }) => {
    return ((0, jsx_runtime_1.jsx)("td", Object.assign({ id: `m_grid_cell_is_active_${ariaColumnIndex}`, colSpan: colSpan, style: style }, { children: "Avg: 127" })));
};
exports.default = customDayFooter;
